import React from "react";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  procedureID: yup.number(),
});

function useSendPostTreatmentInstructionsMutation({ onSuccess, onError } = {}) {
  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return http.get(
        HTTP_ENDPOINTS.getSendPostTreatmentInstructions(req.procedureID),
      );
    },
    onError: () => {
      onError?.();
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
}

export const withSendPostTreatmentInstructionsMutation =
  (Component) => (props) => {
    const sendPostTreatment = useSendPostTreatmentInstructionsMutation();

    return (
      <Component
        {...props}
        sendPostTreatment={sendPostTreatment}
        isLoading={sendPostTreatment.isLoading}
      />
    );
  };
